<template>
  <div class="mini-calendar__events" role="region" aria-label="Event List" ref="events">

    <ul class="mini-calendar__events-list" v-show="eventlist.length > 0">
      <li v-for="(item) in eventlist" :key="item.date_id">
        <MiniCalenderEvent :event="item" />
      </li>
    </ul>

    <div
  class="mini-calendar__events-no-result"
  v-show="eventlist.length === 0 && total >= 0"
>
  <p class="mini-calendar__events-no-result-text">
    <template v-if="!hasFilters && !isMonthView">
      Sorry, no upcoming events at this time.
    </template>
    <template v-else-if="!hasFilters && isMonthView">
      Sorry, no upcoming events for this month.
    </template>
    <template v-else-if="hasFilters && !isMonthView">
      Sorry, no matching events were found.
      <a
        href="javascript:void(0);"
        class="mini-calendar__events-no-result-link"
        @click="showAllEvents"
      >
        Show All Events
      </a>
    </template>
    <template v-else-if="hasFilters && isMonthView">
      Sorry, no matching events were found for this month.
      <a
        href="javascript:void(0);"
        class="mini-calendar__events-no-result-link"
        @click="showAllEvents"
      >
        Start over
      </a>, or go to a different month.
    </template>
  </p>
</div>



    <MiniCalenderPager :scroll="scrollTo" />
  </div>
</template>

<script>
import MiniCalenderEvent from "./mini-calendar-event.vue";
import MiniCalenderPager from "./mini-calendar-pager.vue";
import { getEvents } from './../api'
import { mapGetters, mapActions } from "vuex";
// import { getFilteredEvents } from "./../api";

export default {
  name: "MiniCalenderEvents",
  props: {
    isMonthView: {
      type: Boolean,
      default: false,
    },
    hasFilters: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MiniCalenderEvent,
    MiniCalenderPager,
  },
  computed: {
    ...mapGetters(["eventlist", "date_range", "total"]),
  },
  methods: {
  showAllEvents() {
    this.setLoading(true);

    getEvents()
      .then((eventlist) => {
        this.setEventList({
          eventlist: eventlist.data,
          total: eventlist.query.total,
        });
        this.setClearAll();
        this.setFilter("");
        this.$router.push("/");
        this.setLoading(false);
      })
      .catch(() => {
        this.setLoading(false);
      });
  },
    scrollTo() {
      this.$refs.events.scrollIntoView();
    },
    ...mapActions(["setEventList", "setLoading", "setClearAll", "setFilter"]),
    ...mapGetters(["filter", "search", "date_range"]),
  },
};
</script>
